import React, { Component } from 'react';
import { Box, Divider, Grid, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { Fragment } from 'react';
import { ArrowBack, ArrowCircleLeftOutlined, ArrowCircleRightOutlined, ChevronRight, DocumentScanner, ExpandLess, ExpandMore, FileOpenRounded, NoteAddOutlined, NoteAddRounded, PersonAdd, PersonRemove, PostAddOutlined, PostAddRounded, RestorePageOutlined, RestorePageRounded, Slideshow } from '@mui/icons-material';
import { SIDES } from './EquipementDetails';
import { extension } from 'mime-types';
import RemisePreview from '../Contract/RemisePreview';
import LoanSingle from './LoanSingle';

class LoanHistory extends Component {
    state = { 
        loan: {},
        user: {},
        openContract: false,
        openSingle: false
    }
    
    handleContract = (loan, end) => {
        if (end){
            this.props.handleContract(loan, this.props.USERS[loan.loan_user], "openEndContract")

        } else {
            this.props.handleContract(loan, this.props.USERS[loan.loan_user], "openContract")
        }
    }
    handleSingle = (loan) => {
        this.setState({
            loan, 
            user: this.props.USERS[loan.loan_user],
            openSingle: true
        })
    }
    
    render() {
        const { list, EQUIP, USERS, EQUIPEMENTS, LOANS, EMPLOYEES} = this.props;
        const { openSingle, loan, user} = this.state;
        return (
            <Box p={1}>
                {(openSingle && loan) ?
                    <Box>
                        <IconButton
                            color="inherit"
                            onClick={() => this.setState({ openSingle: false, loan: {}, user:{} })}
                            aria-label="Close"
                            size="large">
                            <ArrowBack />
                        </IconButton>
                        <LoanSingle
                            // {...this.props}
                            loan={loan}
                            user={user}
                        />
                    </Box>
                :
                    <List>
                        {list && list.filter(loan => !loan.loan_status.startsWith("RESA")).map( loan => {
                            return (
                                <Fragment key={loan.loan_id}>
                            
                                    <ListItem >
                                        <ListItemText 
                                            primary={
                                                <Typography variant="body1">
                                                    {USERS[loan.loan_user].username} {USERS[loan.loan_user].lastname}
                                                </Typography>
                                            } 
                                            secondary={
                                                <Typography color="primary">
                                                    {new Date(loan.loan_start_date).toLocaleDateString("fr-FR")} - {new Date(loan.loan_end_date).getFullYear() === 1 ? "En cours" : new Date(loan.loan_end_date).toLocaleDateString("fr-FR")}
                                                </Typography>
                                            }
                                        />
                                        <IconButton
                                            onClick={ () => this.handleContract(loan) }
                                            size="large"
                                        >
                                            <NoteAddRounded color="warning" />
                                        </IconButton>
                                        {loan.is_over &&
                                            <IconButton
                                                onClick={ () => this.handleContract(loan, true) }
                                                size="large"
                                            >
                                                <RestorePageRounded color="success" />
                                            </IconButton>
                                        }
                                        <IconButton
                                            onClick={ () => this.handleSingle(loan) }
                                            size="large"
                                        >
                                            <ChevronRight />
                                        </IconButton>
                                    </ListItem>
                                     
                                    <Divider />
                                </Fragment>
                            )}
                        )}
                    </List>
                }
            </Box>
        );
    }
}

export default LoanHistory;